import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCaretUp = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.37 18.119a.874.874 0 0 1-1.24 0L14 9.987l-8.13 8.132a.875.875 0 0 1-1.24-1.238l8.75-8.75a.876.876 0 0 1 1.24 0l8.75 8.75a.876.876 0 0 1 0 1.238Z" />
  </svg>
);
export default SvgCaretUp;
